<div *ngIf="unConvertedIds.length > 0" class="text-color--red">
  <p class="d-flex align-items-center">
    <p500-ui-icon name="alert-danger-fill" size="16px" class="mr-6"></p500-ui-icon>
    <span i18n="@@finance.currencies_cant_be_converted_warning">WARNING! Currencies can't be converted for the following earnings:</span>
  </p>
  <p class="py-1">{{ unConvertedIds.join(', ') }}</p>
  <p i18n="@@finance.currencies_cant_be_converted_warning_description">
    Request the affiliates to change their default currencies to enable currency conversion
  </p>
</div>
<div *ngIf="unConvertedIds.length === 0 && !!+exchangeFieldControl?.value" class="text-color--red">
  <p class="d-flex align-items-center">
    <p500-ui-icon name="alert-danger-fill" size="16px" class="mr-6"></p500-ui-icon>
    <span i18n="@@finance.exchanging_currency_warning"
      >WARNING: Exchanging currency may cause discrepancies in financial data. Use it at your own risk.</span
    >
  </p>
</div>
